import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const stars = Array(5).fill(0);
  return <section className="bg-crema py-10 sm:py-16 px-5" data-id="element-350">
      <div className="max-w-[900px] mx-auto" data-id="element-351">
        <div className="text-center mb-8 sm:mb-12" data-id="element-352">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-oscuro" data-id="element-353">
            Lo que dicen las esteticistas que ya lo tienen
          </h2>
          <p className="text-[15px] text-gris" data-id="element-354">
            Resultados reales en las primeras 48 horas de uso
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5" data-id="element-355">
          <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-l-4 border-rosa" data-id="element-356">
            <div className="flex text-dorado mb-3" data-id="element-357">
              {stars.map((_, i) => <Star key={i} size={14} className="fill-dorado" data-id="element-358" />)}
            </div>
            <p className="text-[14px] leading-[1.65] text-oscuro mb-4 italic" data-id="element-359">
              "Organicé toda mi comunicación con clientas en un fin de semana.
              Ahora sé exactamente qué mandar antes, durante y después de cada
              turno. Nunca más improviso un mensaje a las 11 de la noche."
            </p>
            <div data-id="element-360">
              <strong className="block text-[13px] font-bold text-oscuro" data-id="element-361">
                Valentina G.
              </strong>
              <span className="text-[12px] text-gris" data-id="element-362">
                Buenos Aires — Cosmiatra independiente
              </span>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-l-4 border-rosa" data-id="element-363">
            <div className="flex text-dorado mb-3" data-id="element-364">
              {stars.map((_, i) => <Star key={i} size={14} className="fill-dorado" data-id="element-365" />)}
            </div>
            <p className="text-[14px] leading-[1.65] text-oscuro mb-4 italic" data-id="element-366">
              "El presupuesto PDF cambió todo. La primera semana que lo empecé a
              usar, cerré 3 turnos que antes se perdían en el chat. Las clientas
              ven que sos profesional antes de pisar el centro."
            </p>
            <div data-id="element-367">
              <strong className="block text-[13px] font-bold text-oscuro" data-id="element-368">
                Romina L.
              </strong>
              <span className="text-[12px] text-gris" data-id="element-369">
                Córdoba — Cosmetóloga en centro propio
              </span>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-l-4 border-rosa" data-id="element-370">
            <div className="flex text-dorado mb-3" data-id="element-371">
              {stars.map((_, i) => <Star key={i} size={14} className="fill-dorado" data-id="element-372" />)}
            </div>
            <p className="text-[14px] leading-[1.65] text-oscuro mb-4 italic" data-id="element-373">
              "Con la calculadora del Tomo 5 descubrí que estaba trabajando casi
              a pérdida en mis limpiezas. Subí el precio, lo comuniqué con el
              método del kit y no perdí ninguna clienta. Gano $90.000 más por
              mes."
            </p>
            <div data-id="element-374">
              <strong className="block text-[13px] font-bold text-oscuro" data-id="element-375">
                Luciana M.
              </strong>
              <span className="text-[12px] text-gris" data-id="element-376">
                Rosario — Esteticista con agenda llena
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}